/**
 * All fileCodeError raised by files service
 * 'ERR_000019', // seems to be deprecated
 */
export enum ProcessingErrorEnum {
  TIMEOUT = 'ERR_TIMEOUT',
  LOCAL_EXEC = 'ERR_LOCAL_EXEC',
  DOWNLOAD_ERROR = 'ERR_000015', // Download customer files error
  MANUAL_PROOFS = 'ERR_000016', // One or more proofs can't be generated (Generally there is products without profile)
  ERROR_DETECTED = 'ERR_000020', // One or more error detected
  MANUAL_CHECK = 'ERR_000021', // A user must check proofs manually (Customer settings callasWarning)
  UPLOAD_ERROR = 'ERR_000023', // Upload generated files error
}
